// Import model
import { StartIndividualContactAddAppointmentRequest } from '../models/StartIndividualContactAddAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartIndividualContactAddAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartIndividualContactAddAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartIndividualContactAddAppointmentRequest instance
   */
  static deserialize(json: string): StartIndividualContactAddAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartIndividualContactAddAppointmentRequest instance
   */
  static fromObject(obj: any): StartIndividualContactAddAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartIndividualContactAddAppointmentRequest');
    }


    const instance: StartIndividualContactAddAppointmentRequest = {
      start: obj['Start'] as string | undefined,
      userId: obj['UserId'] as string | undefined,
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
      message: obj['Message'] as string | undefined,
      sendEmail: obj['SendEmail'] as boolean | undefined,
      duration: obj['Duration'] as string | undefined,
      copyAddress: obj['CopyAddress'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartIndividualContactAddAppointmentRequest instances
   */
  static deserializeArray(json: string): StartIndividualContactAddAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartIndividualContactAddAppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartIndividualContactAddAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartIndividualContactAddAppointmentRequest instance to a plain object
   */
  static toObject(instance: StartIndividualContactAddAppointmentRequest): any {
    return {
      'Start': instance.start,
      'UserId': instance.userId,
      'Name': instance.name,
      'Description': instance.description,
      'Message': instance.message,
      'SendEmail': instance.sendEmail,
      'Duration': instance.duration,
      'CopyAddress': instance.copyAddress,
    };
  }

  /**
   * Serializes an array of StartIndividualContactAddAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartIndividualContactAddAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
